module.exports = __webpack_public_path__ + "static/media/partner2.7d0c6ce4.jpg";